﻿import jquery from 'jquery';
import HabEvents from '../Global/habitaclia-events';

class ModuloLider {
    constructor(moduloLiderDto) {
        this.moduloLiderDto = moduloLiderDto;
        this.timeoutajax = 15000;
        this.configurations = {
            mobile: {
                selectorContainer: '#ajaxModuloLider',
                selectorImages: '#ajaxModuloLider .loadImg',
                classShow: 'mostrar',
                classHide: 'ocultar',
                registerEventsClick: true
                
            },
            desktop: {
                selectorContainer: '#ajaxModuloLider',
                selectorImages: '#ajaxModuloLider .loadImg',
                classShow: 'mostrar',
                classHide: 'ocultar',
                registerEventsClick: false
            }
        };

        this.configName = this.__getConfigName(this.moduloLiderDto.configName);

        this.__$ajaxModuloLider = jquery(this.configurations[this.configName].selectorContainer);

        this.__initCallAjaxLider();
    }

    __getConfigName(configName) {
        if (configName) {
            return configName;
        }

        return 'mobile';
    }

    __initCallAjaxLider () {
        if (!!this.moduloLiderDto.urlModuloLider) {
            const urlModuloLider = this.moduloLiderDto.urlModuloLider;
            const queryString = this.moduloLiderDto.filtrosSerializados.replace(/^&/, '');

            jquery.ajax({
                url: urlModuloLider,
                type: 'GET',
                data: queryString,
                dataType: 'json',
                timeout: this.timeoutajax,
                success: (data) => {
                    if (data && data.Name) {
                        this.__mostrarModuloLider(data);
                    } else {
                        this.__ocultarModuloLider();
                    }
                },
                error: (jqXhr, textStatus, errorThrown) => {
                    this.__ocultarModuloLider();
                    const msg = `Error MostrarModuloLider carga en segundo plano: responseText: ${jqXhr.responseText} textStatus: ${textStatus} errorThrown: ${errorThrown}`;
                    throw msg;
                }
            });

        } else {
            this.__$ajaxModuloLider.remove();
        }
    }

    __loadImagesModuloLider() {

        const images = jquery(this.configurations[this.configName].selectorImages);

        for (let i = 0; i < images.length; i++) {
            const image = images[i];

            if (image.name.length > 0) {
                image.src = image.name;
                image.name = '';
            }
        }
    }

    __setFlagForAdvertising(key, value) {
        window.__mpi = window.__mpi || {};
        window.__mpi.advertising = window.__mpi.advertising || {};
        window.__mpi.advertising.flags = window.__mpi.advertising.flags || {};
        window.__mpi.advertising.flags[key] = value;
    }

    __ocultarModuloLider() {
        this.__$ajaxModuloLider.remove();
        jquery.publish(HabEvents.EventsEnum.ModuloLiderNoCargado);
        this.__setFlagForAdvertising(HabEvents.EventsEnum.ModuloLiderNoCargado, true);
    }

    __mostrarModuloLider(data) {
        const html = this.__buildHtml(data);
        this.__$ajaxModuloLider.html(html);
        this.__$ajaxModuloLider.css('display', '');
        this.__$ajaxModuloLider.removeClass(this.configurations[this.configName].classHide).addClass(this.configurations[this.configName].classShow);

        this.__loadImagesModuloLider();

        if (this.configurations[this.configName].registerEventsClick) {
            this.__registerEventsLider();
        }

        jquery.publish(HabEvents.EventsEnum.ModuloLiderCargado);
    }

    __formatPrice(price) {
        if (!price || price === 0) return this.moduloLiderDto.textos.consultar;
        return price.toLocaleString('de-DE') + ' €';
    }

    __formatSurface(surface) {
        if (!surface || surface === '0') return '';
        return surface + ' m²';
    }

    __formatRooms(rooms) {
        if (!rooms || rooms === '0') return '';
        return rooms + ' h';
    }

    __buildHtml(data) {
        const banner = data.Banner;
        const ads = data.Ads || [];

        const adsHtml = ads.map(ad => {
            const price = this.__formatPrice(ad.Price);
            const surface = this.__formatSurface(ad.Surface);
            const rooms = this.__formatRooms(ad.Rooms);
            const features = [surface, rooms].filter(Boolean).join('  ');
            return `
            <li style="position:relative;padding-bottom:0px;"
                data-url="${ad.Url}"
                data-gtmname="${ad.Gtm.Name}"
                data-gtmid="${ad.Gtm.Id}"
                data-gtmbrand="${ad.Gtm.Brand}"
                data-gtmprice="${ad.Gtm.Price}"
                data-gtmcategory="${ad.Gtm.Category}"
                data-gtmvariant="${ad.Gtm.Variant}"
                data-gtmlist="${ad.Gtm.List}"
                data-gtmposition="${ad.Gtm.Position}"
                class="gtmlistproductviewdestacado">
                <div class="bloquelider">
                    <div class="imglider">
                        <img class="loadImg" name="${ad.MainImage}" src="" alt="${ad.Title}" />
                        <div class="cajondestacadolista">
                            <span class="preciolider">${price}</span>
                            <span class="caracteristicas-lider">${features}</span>
                        </div>
                    </div>
                    <div class="ubiclider">
                        <a href="${ad.Url}">${ad.Title}</a>
                        <span class="ubicacion_destacado">${ad.Location}</span>
                        <span class="destacado_lider">${ad.Description}</span>
                    </div>
                    <div class="preview">
                        <div class="imglider">
                            <img class="loadImg" name="${ad.MainImage}" src="" alt="${ad.Title}" />
                            <div class="cajondestacadolista">
                                <span class="preciolider">${price}</span>
                                <span class="caracteristicas-lider">${features}</span>
                            </div>
                        </div>
                        <div class="ubiclider">
                            <a href="${ad.Url}">${ad.Title}</a>
                            <span class="ubicacion_destacado">${ad.Location}</span>
                            <span class="destacado_lider_completo"><strong>${ad.Description}</strong></span>
                        </div>
                        <div class="verlider">
                            <span class="botonlider">${this.moduloLiderDto.textos.verAnuncio}</span>
                        </div>
                    </div>
                </div>
            </li>`;
        }).join('');

        const bannerHtml = `
                <div class="bannerlider jqModLider gtmclickpromolider"
                     data-gtmid="${banner.Gtm.Id}"
                     data-gtmname="${banner.Gtm.Name}"
                     data-gtmcreative="${banner.Gtm.Creative}"
                     data-gtmposition="${banner.Gtm.Position}"
                     data-url="${banner.MiniSite}"
                     ce="${banner.Tracking.AgencyId}"
                     co="${banner.Tracking.OfficeId}"
                     ids="${banner.Tracking.SupportId}"
                     cc="${banner.Tracking.CampaignId}"
                     cb="${banner.Tracking.BannerId}"
                     url="${banner.MiniSite}">
                    <img class="loadImg" name="${banner.Logo}" src="" alt="${data.Name}" />
                    <div class="inmobiliaria-lider">
                        <ul>
                            <li class="titulo">${this.moduloLiderDto.textos.anuncianteDestacado}</li>
                            ${banner.TotalVenta > 0 ? `<li><strong>${banner.TotalVenta}</strong> en venta</li>` : ''}
                            ${banner.TotalAlquiler > 0 ? `<li><strong>${banner.TotalAlquiler}</strong> en alquiler</li>` : ''}
                            ${banner.TotalON > 0 ? `<li><strong>${banner.TotalON}</strong> de obra nueva</li>` : ''}
                        </ul>
                        <br/><br/><br/>
                        <div class="botoninmobiliarialider">
                            <a class="boton" href="${banner.MiniSite}">${this.moduloLiderDto.textos.verTodosAnuncios}</a>
                        </div>
                    </div>
                </div>`;

        const adsListHtml = ads.length > 0 ? `
                <div class="lider-list-container">
                    <div class="lider-list-full">
                        <ul id="listaliders">${adsHtml}</ul>
                        ${bannerHtml}
                    </div>
                </div>` : bannerHtml;

        return `
            <div class="inmlider">
                <div class="titulo-lider">
                    <span class="lider-name">${data.Name}</span>
                    <span class="lider-desc">${data.Description}</span>
                </div>
                ${adsListHtml}
            </div>`;
    }

    __registerEventsLider() {
        jquery('.gtmlistproductviewdestacado').click((e) => {
            var url = e.currentTarget.getAttribute('data-url');
            window.location = url;
        });

        jquery('.gtmclickpromolider').click(() => {
            window.location = jquery('.botoninmobiliarialider a').attr('href');
        });
    }
}

export default ModuloLider;